module.exports = __webpack_public_path__ + "img/karasahikaku.a4e82178.png";